var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 91,
    viewBox: "0 0 186 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-4{fill:#4b4b4b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shop_Chosen",
    transform: "translate(-604 -653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_820",
    d: "M0 0H186V91H0z",
    className: "cls-1",
    transform: "translate(604 653)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    transform: "translate(-8938 -446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    fill: "#13647b",
    d: "M3254.6 4129.318l4.527 3.233h19.725l2.587-3.233v-9.054s-2.91-1.941-10.348 0-14.875-2.264-14.875-2.264z",
    transform: "translate(6418.241 -2963.029)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    transform: "translate(9563.223 1123.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_262",
    fill: "#13647b",
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0H20V11H0z",
    transform: "translate(-.222 27.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H19.5V10.5H0.5z",
    className: "cls-1",
    transform: "translate(-.222 27.588)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    transform: "translate(.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    d: "M-3875.825 3194.478c-.179.014-.305.031-.432.031-2.1 0-4.2-.005-6.294.008-.339 0-.462-.091-.444-.438.026-.521 0-1.042.01-1.562a1.719 1.719 0 0 1 1.774-1.745q1.8-.012 3.6 0a1.725 1.725 0 0 1 1.783 1.78c.009.634.003 1.268.003 1.926z",
    className: "cls-4",
    transform: "translate(3889.251 -3190.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    d: "M-3935.182 3269.9a11.967 11.967 0 0 0-.521-3.552c-1.559-5.137-3.533-10.124-5.479-15.12a.817.817 0 0 0-.876-.554c-1.9.01-3.8.008-5.7.01-.859 0-.92.023-1.214.82-1.636 4.417-3.288 8.826-4.878 13.26a13.587 13.587 0 0 0-1.018 4.735c.029 3.06.008 6.12.008 9.18V3288.207a5.266 5.266 0 0 0 5.434 5.444h8.7a5.263 5.263 0 0 0 5.53-5.519c.007-6.075-.004-12.151.014-18.232zm-16.958-6.067c1.387-3.826 2.838-7.628 4.254-11.444a.519.519 0 0 1 .577-.388c1.535.015 3.073.01 4.608 0a.469.469 0 0 1 .525.332c1.841 4.786 3.721 9.555 5.223 14.465a16.185 16.185 0 0 1 .423 4.694c0 .282-.172.286-.375.284h-8.134c-2.652 0-5.306-.01-7.959.01-.427 0-.492-.141-.532-.54a16.737 16.737 0 0 1 1.39-7.409zm15.607 24.485a3.933 3.933 0 0 1-4 3.992q-4.524.011-9.048-.007a3.869 3.869 0 0 1-3.907-3.712c-.056-1.187-.006-2.377-.026-3.566-.007-.394.232-.356.485-.356h8c2.668 0 5.336 0 8-.008.37 0 .511.086.5.481-.022 1.064.008 2.123-.004 3.18zm.015-5.158h-16.969v-9.921h16.969z",
    className: "cls-4",
    transform: "translate(3954.867 -3245.464)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    transform: "translate(42.658 14.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    d: "M-3054.874 3753.84c1.156 0 2.239-.024 3.322 0a45.211 45.211 0 0 1 9.313 1.044c.423.1.842.215 1.257.341a.678.678 0 0 1 .526.771c-.028 2.376-.021 4.753-.021 7.129v15.043c0 .941-.042 1.885.011 2.824.042.728-.465 1.153-1.246.945a18.921 18.921 0 0 0-2.75-.617c-2.36-.263-4.723-.525-7.093-.634a54.272 54.272 0 0 0-10.567.677 50.028 50.028 0 0 1-11.926.3 30.669 30.669 0 0 1-6.913-1.228 12.688 12.688 0 0 1-2.215-.986 2.409 2.409 0 0 1-1.3-2.281q.037-12.259 0-24.519a2.312 2.312 0 0 1 1.027-1.993 9.708 9.708 0 0 1 3.334-1.427 36.639 36.639 0 0 1 6.345-.993 52.566 52.566 0 0 1 10.286.143 25.352 25.352 0 0 1 6.521 1.4 8.038 8.038 0 0 1 1.359.673c1.443.923 1.656 1.882.73 3.388zm-27.91.8v6.239q0 8.192-.01 16.386a.791.791 0 0 0 .461.808 14.771 14.771 0 0 0 1.62.723 26.713 26.713 0 0 0 5.915 1.144 49.934 49.934 0 0 0 9.42.1c2.176-.2 4.338-.547 6.514-.765a52.728 52.728 0 0 1 15.152.5c.517.1 1.039.182 1.609.281v-.541q0-6.063.008-12.127c0-3.434-.009-6.868 0-10.3 0-.361-.1-.518-.46-.58-.684-.118-1.355-.333-2.042-.405-2.1-.221-4.205-.44-6.313-.571a47.767 47.767 0 0 0-9.967.49 57.216 57.216 0 0 1-9.4.663 43.55 43.55 0 0 1-9.311-1.036c-1.057-.265-2.086-.657-3.196-1.006zm13.317.367l.008.109c2.138-.159 4.286-.232 6.408-.5a44.207 44.207 0 0 0 4.966-1.024 7.459 7.459 0 0 0 1.808-.825c.41-.23.4-.5.025-.779a3.986 3.986 0 0 0-.786-.456 19.668 19.668 0 0 0-5.118-1.314 50.021 50.021 0 0 0-8.585-.46 35.7 35.7 0 0 0-9.409 1.227 13.379 13.379 0 0 0-2.271.956c-.486.25-.453.576 0 .893.059.041.124.077.187.112a12.97 12.97 0 0 0 3.945 1.288 43.746 43.746 0 0 0 8.822.776z",
    className: "cls-4",
    transform: "translate(3084.478 -3748.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    d: "M-2835.676 3919.625a3.181 3.181 0 0 1-.717-.614.773.773 0 0 1 .2-.986q1.138-1.136 2.273-2.276l6.056-6.053c.071-.07.142-.145.217-.212a.822.822 0 0 1 1.2-.016.809.809 0 0 1-.035 1.2c-.943.963-1.9 1.913-2.853 2.866q-2.8 2.795-5.6 5.585a5.28 5.28 0 0 1-.741.506z",
    className: "cls-4",
    transform: "translate(2858.062 -3895.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    d: "M-2752.6 3943.011a3.256 3.256 0 0 1-.384.669q-2.333 2.361-4.692 4.7a.814.814 0 0 1-1.231.013.811.811 0 0 1 .063-1.2q2.342-2.355 4.7-4.7a.752.752 0 0 1 .95-.178 2.948 2.948 0 0 1 .594.696z",
    className: "cls-4",
    transform: "translate(2787.427 -3925.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    d: "M-2683.676 3974.566c.205.167.522.309.623.541a.975.975 0 0 1-.057.832 12.766 12.766 0 0 1-1.425 1.453.773.773 0 0 1-1.066-.054.768.768 0 0 1-.108-1.061c.46-.518.962-1 1.466-1.473a2.055 2.055 0 0 1 .567-.238z",
    className: "cls-4",
    transform: "translate(2720.537 -3954.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    d: "M-2953.233 3785.046c1.081.171 2.17.31 3.24.532.294.061.736.346.762.567.052.428-.447.5-.78.6a12.2 12.2 0 0 1-4.606.335 19.888 19.888 0 0 1-2-.369.74.74 0 0 1-.32-.126c-.147-.125-.388-.3-.371-.42a.646.646 0 0 1 .394-.441c.793-.205 1.6-.384 2.406-.515a7.978 7.978 0 0 1 1.256-.011z",
    className: "cls-4",
    transform: "translate(2968.367 -3781.83)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    transform: "translate(109.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    d: "M-3475.047 1618.107v3.916h-1.948V1626h.9a2.96 2.96 0 0 1 3.017 3c.013.949.009 1.9 0 2.848a.333.333 0 0 0 .279.388 8.844 8.844 0 0 1 6.622 7.86q1.1 8.229 2.193 16.457a8.91 8.91 0 0 1 .124 3.142 4.921 4.921 0 0 1-4.768 3.881q-9.395.015-18.787 0a4.935 4.935 0 0 1-4.834-5.685q1.153-8.56 2.278-17.123a10.971 10.971 0 0 1 1.326-4.47 8.871 8.871 0 0 1 5.274-4.027.471.471 0 0 0 .413-.564c-.019-.9-.011-1.793 0-2.689a2.947 2.947 0 0 1 3.032-3.018h.894v-3.959h-1.947v-3.962h-4.927v-1.971h.419q8.6 0 17.2.007a1.655 1.655 0 0 1 .713.163q3.684 1.822 7.355 3.67c.129.064.256.133.437.228-.291.58-.574 1.15-.874 1.751-.151-.071-.279-.129-.4-.192l-7.037-3.511a1.142 1.142 0 0 0-.481-.141c-2.1-.009-4.192-.006-6.288 0a1.534 1.534 0 0 0-.185.024zm-2.978 43.5h9.134a2.959 2.959 0 0 0 3.121-3.517c-.151-1.242-.327-2.482-.492-3.723-.626-4.7-1.272-9.4-1.876-14.1a6.985 6.985 0 0 0-7.13-6.359c-1.95-.008-3.9-.02-5.853.007a6.871 6.871 0 0 0-6.643 5.6c-.333 1.893-.537 3.808-.792 5.715q-.778 5.8-1.548 11.6c-.067.5-.148.991-.191 1.49a2.937 2.937 0 0 0 2.976 3.288c3.097.009 6.196 0 9.294.001zm-2.942-29.705h5.909c0-1.027.023-2.026-.009-3.023a.933.933 0 0 0-.97-.905q-2-.023-3.989 0a.907.907 0 0 0-.931.807c-.034 1.037-.011 2.073-.011 3.119zm1.979-11.867h1.93v-1.935h-1.93z",
    className: "cls-4",
    transform: "translate(3492.292 -1616.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    d: "M-3124.22 1720.791a7.96 7.96 0 0 1 1.249-3.641 3.109 3.109 0 0 1 .323-.4 1.755 1.755 0 0 1 2.787.02 5.99 5.99 0 0 1 1.336 2.824 5.842 5.842 0 0 1 .177 1.831 2.9 2.9 0 0 1-3.2 2.549 3 3 0 0 1-2.672-3.183zm2.954-2.7a5.478 5.478 0 0 0-.948 3.148.93.93 0 0 0 1 .765.947.947 0 0 0 .925-.91 5.894 5.894 0 0 0-.977-2.999z",
    className: "cls-4",
    transform: "translate(3153.34 -1708.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    d: "M-3429.863 2143.443v-1.593c0-.1.012-.2.021-.327h18.613v1.92z",
    className: "cls-4",
    transform: "translate(3434.802 -2099.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    d: "M-3409.221 1870.572l-1.914-.257a4.1 4.1 0 0 1 .583-1.773 4.822 4.822 0 0 1 4.259-2.509c2.017-.034 4.035-.015 6.052-.005a4.956 4.956 0 0 1 4.756 3.906c.023.113.025.229.043.382l-1.9.255c-.034-.108-.064-.192-.085-.278a2.942 2.942 0 0 0-2.789-2.285q-3.066-.045-6.131 0c-1.421.023-2.409.934-2.874 2.564z",
    className: "cls-4",
    transform: "translate(3417.556 -1846.242)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    fill: "#fff",
    stroke: "#4b4b4b",
    strokeWidth: "2px",
    d: "M9266.595 601s6.069 3.2 9.917 2.932 9.058-3.367 14.631 0",
    transform: "translate(408.668 553.971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopChosen);
export default __webpack_public_path__ + "static/media/shop-chosen.cbd27f087c20517a0c2c7f7c962878b9.svg";
export { ForwardRef as ReactComponent };